import clsx from "clsx"
import { FC, memo } from "react"
import { useTranslation } from "react-i18next"
import { UserUndefinedImg } from "@/assets"
import { Container } from "@/ui/Container"
import { ImageLoader } from "@/ui/ImageLoader"
import styles from "./PlayerStatus.module.scss"
import { IPlayerStatus } from "./types"

export const PlayerStatusComponent: FC<IPlayerStatus> = ({
  avatar,
  name,
  isReady,
  style = "common"
}) => {
  const { t } = useTranslation()

  return (
    <Container
      className={clsx(styles.PlayerStatus, styles[style], {
        [styles.ready]: isReady
      })}
    >
      <div className={clsx(styles.PlayerStatus_avatar)}>
        <ImageLoader src={avatar || UserUndefinedImg} spinner={{ size: 18 }} />
      </div>
      <div className={clsx(styles.PlayerStatus_nameWrapper)}>
        <div className={clsx(styles.PlayerStatus_name)}>
          {name || t("playerStatus.waiting")}
        </div>
      </div>
      {isReady !== undefined && (
        <div className={clsx(styles.PlayerStatus_status)}>
          {isReady ? t("playerStatus.ready") : t("playerStatus.notReady")}
        </div>
      )}
    </Container>
  )
}

export const PlayerStatus = memo(PlayerStatusComponent)
